/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface ICustomerPortalCustomers {
    getServiceAddresses(cancelToken?: CancelToken): AxiosPromise<CustomerLocationsModel[]>;
}

export const BASE_URL_TOKEN_CustomerPortalCustomers = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class CustomerPortalCustomers implements ICustomerPortalCustomers {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private readonly axios: AxiosInstance, private readonly baseUrl = '') {}

    getServiceAddresses(cancelToken?: CancelToken): AxiosPromise<CustomerLocationsModel[]> {
        let url_ = '/v1/customerportal2/customers/service-addresses';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<CustomerLocationsModel[]>(options_));
    }
}

export interface CustomerLocationsModel {
    id: number;
    name: string;
    locations: LocationModel[];
}

export interface LocationModel {
    id: number;
    name: string;
    address?: AddressModel | undefined;
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}
